import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

Router.prototype.open = function (routeObject) {
  const {href} = this.resolve(routeObject)
  window.open(href, '_blank')
}

export default new Router({
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Home',
    component: () => import('@/pages/home.vue')
  },
  {
    path: '/howDoWeDoIt',
    alias:'/comolohacemos',
    name: 'Como lo hacemos',
    component: () => import('@/pages/howDoWeDoIt.vue')
  },
  {
    path: '/aboutUs',
    alias:'/nosotros',
    name: 'Nosotros',
    component: () => import('@/pages/aboutUs.vue')
  },
  {
    path: '/projects',
    alias:'/proyectos',
    name: 'Proyectos',
    component: () => import('@/pages/projects.vue')
  },
  {
    path: '/donations',
    alias:'/donaciones',
    name: 'Donaciones',
    component: () => import('@/pages/donations.vue')
  },
  {
    path: '/museum',
    alias:'/museo',
    name: 'Museo',
    component: () => import('@/pages/museum.vue')
  },
  {
    path: '/contact',
    alias:'/contacto',
    name: 'Contacto',
    component: () => import('@/pages/contact.vue')
  },
  {
    path: '/recondition',
    alias:'/reacondicionar',
    name: 'Reacondicionar',
    component: () => import('@/pages/recondition.vue')
  },
  {
    path: '/travelingComputers',
    alias:'/computadoresviajeros',
    name: 'Computadores viajeros',
    component: () => import('@/pages/travelingComputers.vue')
  },
  {
    path: '/virtualCommunity',
    alias:'/comunidadvirtual',
    name: 'Comunidad virtual',
    component: () => import('@/pages/virtualCommunity.vue')
  },
  { path: "*", component: () => import('@/components/notFound.vue') }]
})



